import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";

export const SideListMenu = (props) => {
    const { i18n, t } = useTranslation();
    const [models, setModels] = useState([]);

    useEffect(() => {
        if (props.db) {
            setModels(props.db.furnitures
                .map(el => ({
                    SKU: el.SKU,
                    name: el.name,
                    type: t(el.type),
                    new: el.isNew,
                    archived: el.archived
                }))
                .sort((a, b) => {
                    // D’abord, on compare les types
                    const typeCompare = a.type.localeCompare(b.type);
                    if (typeCompare !== 0) return typeCompare;
                    // Si les types sont identiques, on compare les noms
                    return a.name.localeCompare(b.name);
                }))
        }
    }, [props.db]);

    return (
        <div id='sideMenu' >
            {
                models.filter(el => !el.archived).map((el, i) => {
                    const isActive = props.modelCode?.model === el.SKU ? "active" : "";
                    return (
                        <div onClick={() => {
                            if (!isActive) {
                                props.AppLoaded();
                                props.setModelCode({ model: el.SKU });
                                props.settmpInit(true);
                            }
                        }
                        } key={i} className={`listElement ${isActive}`}>
                            <p>{el.type}</p>
                            <p>-</p>
                            <p className="bold">{el.name}</p>
                        </div>
                    )
                })
            }
        </div>
    )
}